var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99957 9.06897C12.2278 9.06897 14.0341 7.26267 14.0341 5.03448C14.0341 2.8063 12.2278 1 9.99957 1C7.77138 1 5.96507 2.8063 5.96507 5.03448C5.96507 7.26267 7.77138 9.06897 9.99957 9.06897Z",
    stroke: "url(#paint0_linear_73_1102)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60343 19H16.3959C17.8134 19 18.9054 17.7811 18.2435 16.5277C17.2696 14.6839 15.0496 12.4828 9.99967 12.4828C4.94972 12.4828 2.72971 14.6839 1.75593 16.5277C1.09393 17.7811 2.18587 19 3.60343 19Z",
    stroke: "url(#paint1_linear_73_1102)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_73_1102",
    x1: 3.92989,
    y1: 3.65264,
    x2: 21.0344,
    y2: 7.54634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BADCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_73_1102",
    x1: 3.92989,
    y1: 3.65264,
    x2: 21.0344,
    y2: 7.54634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BADCE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.7c80352dcd823d3f2037c0c8502b90f1.svg";
export { ForwardRef as ReactComponent };